// Vuex users module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  filteringCriteria: {},
  list: {
    page: 1,
    records: [],
    total: 0,
  },
  recordsPerPage: 20,
  isEmptyClients: false,
};

const getters = {
  list: state => state.list,
  isEmptyClientList: state => state.isEmptyClients,
  filteringCriteria: state => state.filteringCriteria,
  recordsPerPage: state => state.recordsPerPage,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
